import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/system';
import { createIndexArray } from 'hx-util';
export function StaticCircles(_a) {
    var _b = _a.size, size = _b === void 0 ? 7.25 : _b, children = _a.children, color = _a.color, _c = _a.offset, offset = _c === void 0 ? 3 : _c, _d = _a.count, count = _d === void 0 ? 4 : _d, _e = _a.opacity, opacity = _e === void 0 ? 0.1 : _e, opacityTransform = _a.opacityTransform;
    var offsets = createIndexArray(count);
    return (_jsxs(Wrapper, { children: [offsets.map(function (index) { return (_jsx(Circles, { color: color, size: "".concat(size + offset * index, "rem"), opacity: (opacityTransform === null || opacityTransform === void 0 ? void 0 : opacityTransform(index, count)) || opacity }, "circles-".concat(index))); }), children] }));
}
var Circles = styled('div', {
    shouldForwardProp: function (prop) {
        return prop !== 'color' && prop !== 'size' && prop !== 'opacity';
    },
})(function (_a) {
    var theme = _a.theme, color = _a.color, size = _a.size, opacity = _a.opacity;
    return ({
        minHeight: size,
        minWidth: size,
        borderRadius: '99999px',
        backgroundColor: color || theme.palette.primary.main,
        position: 'absolute',
        zIndex: -2,
        opacity: opacity || 1,
    });
});
var Wrapper = styled('div')({
    display: 'grid',
    placeItems: 'center',
    position: 'relative',
});
